import { render } from "./OrganizationDialog.vue?vue&type=template&id=2f24a61c&scoped=true"
import script from "./OrganizationDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationDialog.vue?vue&type=script&lang=js"

import "./OrganizationDialog.vue?vue&type=style&index=0&id=2f24a61c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f24a61c"]])

export default __exports__